import React from 'react';
import { spacing } from '@tq/ui-components/dist/components/mobile-options-accordion/styles/theme/spacing';
import { DetailsCardBody, Box } from '@tq/ui-components';

import { ExpandableParagraph } from 'components';
import { isRpc } from 'tools';
import { CARD_LEFT_PADDING_SIZE } from '../../constants';
import { ConsultationCardProps } from '../../types';

export const ConsultationCardBody: React.FC<ConsultationCardProps> = ({ consultation }) => {
  return isRpc(consultation) ? null : (
    <DetailsCardBody>
      <Box
        ml={{ base: 0, lg: CARD_LEFT_PADDING_SIZE }}
        pr={{ base: 0, lg: spacing(6) }}
        mt={{ base: 2, lg: 0 }}
      >
        <ExpandableParagraph maxCharacters={{ base: 50, xs: 60, sm: 80, md: 90, lg: 100 }}>
          {consultation.summaryDescription}
        </ExpandableParagraph>
      </Box>
    </DetailsCardBody>
  );
};
